import { Monitor, Moon, Sun } from 'lucide-react';
import {
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
} from '@/components/ui/dropdown-menu';
import { useTemaStore, type Tema } from '@/stores/temaStore';

/** Sol ou lua na barra de cima: um clique troca entre claro e escuro. */
export default function BotaoTema() {
  const escuro = useTemaStore((estado) => estado.escuro);
  const escolher = useTemaStore((estado) => estado.escolher);
  const rotulo = escuro ? 'Mudar para o tema claro' : 'Mudar para o tema escuro';

  return (
    <button
      type="button"
      onClick={() => escolher(escuro ? 'claro' : 'escuro')}
      title={rotulo}
      aria-label={rotulo}
      className="inline-flex size-8 items-center justify-center rounded-md text-muted hover:bg-surface-subtle hover:text-ink"
    >
      {escuro ? <Sun size={16} /> : <Moon size={16} />}
    </button>
  );
}

const OPCOES: { valor: Tema; rotulo: string; icone: typeof Sun }[] = [
  { valor: 'claro', rotulo: 'Claro', icone: Sun },
  { valor: 'escuro', rotulo: 'Escuro', icone: Moon },
  { valor: 'sistema', rotulo: 'Igual ao Windows', icone: Monitor },
];

/** As três opções dentro do menu do usuário — é onde fica o "igual ao sistema". */
export function OpcoesDeTema() {
  const tema = useTemaStore((estado) => estado.tema);
  const escolher = useTemaStore((estado) => estado.escolher);

  return (
    <>
      <DropdownMenuLabel className="text-muted">Tema</DropdownMenuLabel>
      <DropdownMenuRadioGroup value={tema} onValueChange={(valor) => escolher(valor as Tema)}>
        {OPCOES.map(({ valor, rotulo, icone: Icone }) => (
          <DropdownMenuRadioItem key={valor} value={valor}>
            <Icone size={14} />
            {rotulo}
          </DropdownMenuRadioItem>
        ))}
      </DropdownMenuRadioGroup>
    </>
  );
}
